<div id="pdf-container" class="pdf-container scrollbar-custom">
    <ng-container>
        <div class="actions" *ngIf="pdf">
            <button class="btn-action download" (click)="download()" title="Download" *ngIf="canDownload"></button>
            <button class="btn-action print" (click)="print()" title="Print" *ngIf="canPrint"></button>
        </div>
        <pdf-viewer  [src]="urlPDF" [original-size]="true" [zoom]="1.2" style="display: block;" (on-progress)="onProgress($event)"
        (error)="onError()" (after-load-complete)="onLoaded($event)"></pdf-viewer>
    </ng-container>

    <div *ngIf="!loaded && !errorHash && !errorHashPDF">
        <div class="overlay-pdf-viewer align-center-item">
        </div>
        <div class="align-center-item">
            <div class="spinner-border"></div>
            <div class="text-center" style="color:#ffffff">{{progress}}</div>
        </div>
    </div>

    <div *ngIf="loaded && hasError" class="align-center-item">
        <span style="font-size: 18px;">Action not yet performed</span>
    </div>

    <div *ngIf="errorHash || errorHashPDF" class="align-center-item">
        <span style="font-size: 18px;">{{errorHash}}</span>
    </div>
</div>
